import { motion } from "framer-motion";
import { FaBuilding, FaDraftingCompass, FaHardHat, FaTools, FaTruckLoading } from "react-icons/fa";
import { Link } from 'react-router-dom';
import edu from '../assets/academic.jpg';
import heroImage from '../assets/bg.jpg';
import bricks from "../assets/bricks.jpg";
import church from '../assets/church2.webp';
import commercial from '../assets/comm2.jpg';
import heal from '../assets/health.jpg';
import abtimg from '../assets/jcp5.jpg';
import industry from '../assets/industry2.jpg';
import equipmentImg from '../assets/jcp.jpg';
import res from '../assets/residence.jpg';
import sand from "../assets/sand.jpg";
import steel1 from "../assets/steel2.png";
const industries = [
  { title: "Residential Buildings", image: res },
  { title: "Commercial Buildings", image: commercial },
  { title: "Religious & Community Buildings", image: church },
  { title: "Educational Institutions", image: edu },
  { title: "Healthcare Facilities", image: heal },
  { title: "Industrial Facilities", image: industry },
];

const factors = [
  {
    icon: <FaBuilding className="text-primary text-3xl" />,
    number: "01",
    title: "Expert Design & Planning",
    description: "We deliver efficient architectural and structural designs tailored to your project needs."
  },
  {
    icon: <FaHardHat className="text-primary text-3xl" />,
    number: "02",
    title: "Quality Construction",
    description: "From foundation to finishing, our focus is on durability, safety, and craftsmanship."
  },
  {
    icon: <FaDraftingCompass className="text-primary text-3xl" />,
    number: "03",
    title: "Project Management",
    description: "We manage every stage of your project to ensure it’s completed on time and within budget."
  },
  {
    icon: <FaTools className="text-primary text-3xl" />,
    number: "04",
    title: "Maintenance & Renovation",
    description: "We offer maintenance, repair, and renovation services for both new and existing structures."
  },
];

const materials = [
  {
    id: 2,
    name: "Bricks",
    image: bricks,
  },
  {
    id: 3,
    name: "Steel Rods",
    image: steel1,
  },
  {
    id: 4,
    name: "Sand",
    image: sand,
  },
];

const highlights = [
  {
    icon: <FaDraftingCompass />,
    text: "Professional building design and planning",
  },
  {
    icon: <FaBuilding />,
    text: "Complete construction services",
  },
  {
    icon: <FaTruckLoading />,
    text: "Reliable supply of quality building materials",
  },
  {
    icon: <FaTools />,
    text: "Modern construction machinery and equipment available for rent",
  },
  {
    icon: <FaHardHat />,
    text: "Building renovation, upgrades, and structural improvements",
  },
];



function BuildConstruction() {
  return (
    <div>
      <section
        className="relative w-full h-[30vh] md:h-[40vh] bg-cover bg-center mb-16"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-75"></div>
        <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 max-w-6xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl  font-bold mb-4">
            Construction & Civil Services
          </h1>
          <div className="flex items-center text-sm md:text-base space-x-2 text-gray-200">
            <Link to="/" className="hover:text-white cursor-pointer">
              Home
            </Link>
            <span>/</span>
            <Link to="/about" className="text-gray-300 underline hover:text-white cursor-pointer">
              Building Construction
            </Link>
          </div>
        </div>
      </section>

      <section className="py-10 mb-10 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* Left Image Section */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src={equipmentImg}
              alt="Equipment Rental"
              loading="lazy"
              className="w-full h-[420px] md:h-[500px] object-cover rounded-lg shadow-lg"
            />

            {/* Vertical Badge */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2 }}
              viewport={{ once: true }}
              className="absolute right-0 bottom-0 -translate-y-1/2 -translate-x-1/2 bg-primary text-secondary py-6 px-4 rounded-r-sm shadow-md flex items-center justify-center"
              style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            >
              <p className="text-xl font-semibold tracking-wide uppercase whitespace-nowrap">
                Trusted Construction Partner
              </p>
            </motion.div>
          </motion.div>

          {/* Right Content */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            <p className="uppercase tracking-widest text-sm font-semibold text-gray-500 mb-1">
              Trusted Partner
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-tight">
              Comprehensive  <span className="text-primary"> Construction Services </span>
            </h2>
            <p className="text-gray-600 mb-5 text-lg">
              From heavy equipment to essential tools, we ensure fast access, top performance, and professional support
              to keep your projects running smoothly and on schedule.
            </p>

            {/* Key Highlights */}
            <div className="space-y-5">
              {highlights.map((item, index) => (
                <motion.div
                  key={index}
                  className="flex items-start gap-4"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  viewport={{ once: true }}
                >
                  <div className="text-primary text-2xl">{item.icon}</div>
                  <p className="text-gray-700 text-lg font-medium">{item.text}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 mb-16">
        {/* Key Highlights */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">

          {/* Card 1 (shorter) */}
          <div className="bg-white p-6 rounded-lg shadow hover:shadow-md transition flex flex-col justify-center h-48 self-center">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Quality Workmanship</h3>
            <p className="text-gray-600">
              Our team ensures every project is built with precision, durability,
              and a commitment to excellence.
            </p>
          </div>

          {/* Center Card (taller) */}
          <div className="bg-secondary/80 p-8 rounded-lg border border-primary shadow-lg hover:scale-105 transition transform flex flex-col justify-center h-72">
            <h3 className="text-2xl font-semibold text-gray-100 mb-4">Innovative Solutions</h3>
            <p className="text-gray-300 text-lg leading-relaxed">
              We adopt modern construction practices and sustainable approaches
              to deliver long-lasting results. Our innovative mindset ensures
              that every project is both functional and future-ready.
            </p>
          </div>

          {/* Card 3 (shorter) */}
          <div className="bg-white p-6 rounded-lg shadow hover:shadow-md transition flex flex-col justify-center h-48 self-center">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Trusted Expertise</h3>
            <p className="text-gray-600">
              With years of industry experience, we are a trusted partner in
              bringing your construction vision to life.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Areas of Specialization
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <div key={index} className="relative overflow-hidden rounded-sm shadow-lg group">
              {/* Industry Image */}
              <img
                src={industry.image}
                alt={industry.title}
                loading="lazy"
                className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
              />

              {/* Overlay on hover */}
              <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 flex items-center justify-center h-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <h3 className="text-white text-xl lg:text-2xl font-semibold text-center px-2">
                  {industry.title}
                </h3>
              </div>

            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-gray-50 mb-16">
        <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-4 flex-col md:flex-row gap-8">

          {/* Left Column: Title + Factors */}
          <div className="md:flex-1 flex flex-col md:col-span-3">
            <h2 className="text-3xl md:text-4xl font-bold mb-8">
              Why Choose Us
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 flex-1">
              {factors.map((factor, index) => (
                <div
                  key={index}
                  className="bg-white p-4 rounded shadow hover:shadow-md transition flex gap-4 items-center"
                >
                  {/* Icon */}
                  <div className='bg-secondary p-3 rounded-full'>{factor.icon}</div>

                  {/* Text column */}
                  <div className="flex flex-col">
                    <span className="text-primary font-bold text-lg">{factor.number}</span>
                    <h3 className="text-gray-800 font-semibold text-xl">{factor.title}</h3>
                    <p className="text-gray-600">{factor.description}</p>
                  </div>
                </div>

              ))}
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="md:flex-1 flex md:col-span-1">
            <img
              src={abtimg}
              alt="Our Team at Work"
              loading="lazy"
              className="w-full h-full object-cover rounded shadow"
            />
          </div>

        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-12 text-center bg-secondary rounded-lg shadow-md mb-16">
        <div className="flex flex-col md:flex-row justify-between items-start gap-6">

          {/* Left Side: Title */}
          <div className="flex flex-col justify-start flex-1">
            <h1 className="text-2xl md:text-3xl font-bold text-start text-white leading-snug">
              Ready to Begin Your Construction Project? <br />
              <span className="text-gray-500 text-start block">
                We’re here to build your vision from the ground up.
              </span>
            </h1>
          </div>

          {/* Right Side: Text + Button */}
          <div className="flex flex-col md:items-start items-center gap-4">
            {/* Paragraph hidden on mobile */}
            <p className="hidden md:block text-white mb-4 max-w-md text-start">
              Partner with us for quality, reliability, and professionalism in every
              phase of your construction journey. Let’s make your dream project a reality.
            </p>

            <Link to="/quote">
              <button className="bg-primary text-secondary font-semibold px-6 py-3 rounded-lg shadow hover:bg-primary/80 transition">
                Request a Quote
              </button></Link>

          </div>

        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          {/* Heading and Button Row */}
          <div className="flex flex-col sm:flex-row justify-between items-center mb-10">
            <h2 className="text-3xl font-bold text-gray-800 mb-4 sm:mb-0">
              Some of Our Building Materials
            </h2>
            <Link
              to="/products"
              className="bg-gray-900 hover:bg-gray-800 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300"
            >
              More Materials
            </Link>
          </div>

          {/* Image Grid */}
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {materials.slice(0, 4).map((item, index) => (

              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                className="relative overflow-hidden rounded-md shadow-md group cursor-pointer"
              >
                {/* Image */}
                <img
                  src={item.image}
                  alt={item.name}
                  loading="lazy"
                  className="w-full h-[400px] object-cover transform group-hover:scale-105 transition-transform duration-500"
                />

                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-50 transition-all duration-500"></div>

                {/* Bordered Overlay Box */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
                  <div className="border-2 border-primary w-[90%] h-[85%] flex items-center justify-center text-white text-xl font-semibold bg-black bg-opacity-30 rounded-md backdrop-blur-sm">
                    {item.name}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

    </div>
  )
}

export default BuildConstruction
